(function (appComponents) {

	appComponents.controllers.index = function (Components) {
		var index = {};

		index.name = "index";


		Components.getControllerPrototype().extend(index);

		index._b2bUnit = index._getService("b2bUnit");
		index._orders = index._getService("ordersBase");
		index._quotes = index._getService("quotesBase");
		index._whereToBuy = index._getService("whereToBuy");
		index._modals = index._getService("modals");
		index._helpers = index._getService("helpers");
		index.opts = {
			numToDisplay: 4,
			// initial value with all motors enabled
			circlesToDisplay: 5
		};

		// bleeeh
		index.currentTabView = (index._role.type == "epc") ? "quotes" : "orders";

		index.elements = {
				get ordersAndQuotes() {
					return $('[pc-component="index--orders-and-quotes"]');
				},
				get advancedSearchHomeBar(){
					return $('.dis-inline-table');
				},
				get systemComponents() {
					return $('[pc-container="system--components--li"]');
				},
				get feedbackModalRMContact() {
					return $('[pc-container="feedback-modal--index--rmcontact"]');
				},
				get bannerContent(){
					return $('[pc-container="banner-content-message"]');
				}
		};

		index.bindings = function () {

			$(document).off("click", '[pc-container="index--set-view-btn"]').on("click", '[pc-container="index--set-view-btn"]', function () {
				var tabView = $(this).attr("pc-value");
				index.handlers.onSetTabView(tabView);
			});
			
			$(document).on("submit", "form[pc-container='rm--feedback--contact-form']", function () {
				index.handlers.onRMContactFeedbackFormSubmit(this);
				return false;
			});

		};

		index.liveBindings = function () {
			//landing page category circle carousel
			$('.category-circle').owlCarousel({
				responsive: true,
				itemsCustom: [
					[0, 1],
					[768, 3],
					[992, index.opts.circlesToDisplay],
					[1200, index.opts.circlesToDisplay]
				]
			});
			
			$('.motors-lv-rm').click(function (e) {
				var unitType = index._b2bUnit.unitType;
				if (unitType == "SAP"){
					app.components.getService("modals").warning.show(app.constants.messages.noCatalogAccessErrorMsg);
					e.preventDefault();
					return false;
				}
			});
			
			$('.parts-lv-rm').click(function (e) {
				var unitType = index._b2bUnit.unitType;
				if (unitType == "ORACLE"){
					app.components.getService("modals").warning.show(app.constants.messages.noCatalogAccessErrorMsg);
					e.preventDefault();
					return false;
				}
			});
			
		};

		index.populateInitialContext = function () {
			
			// index.context.unitType = index._b2bUnit.unitType;
			return $.Deferred().resolve();
		};

		index.setCirclesToDisplay = function () {
			index.opts.circlesToDisplay = 5;
			if (!index._config.isSmallMotorsEnabled) {
				index.opts.circlesToDisplay = index.opts.circlesToDisplay - 1;
			}
			if (!index._config.isCustomMotorsEnabled) {
				index.opts.circlesToDisplay = index.opts.circlesToDisplay - 1;
			}
		};
		
		index.pageOnLoad = function() {
			$(document).ready(function() {
			if(index.context.flags.isUser){
				var cookie=$.cookie("prevUrl");
				if(cookie != null)
					{
					window.location.href=cookie;
					}
				var data = "";
				for(a in index._config.rmHomeContentLong){
					if(index._config.rmHomeContentLong[a].data){
						data = data + index._config.rmHomeContentLong[a].data;
					}else{
						data = data + index._config.rmHomeContentLong[a].outerHTML;
						
					}
				}

				if(document.getElementsByClassName('banner-home-long') != undefined && document.getElementsByClassName('banner-home-long')[0] != undefined){
					document.getElementsByClassName('banner-home-long')[0].innerHTML = data;
				}
			}
			else if(index.context.flags.isGuest){
				var dataShort = "";
				for(a in index._config.rmHomeContentShort){
					if(index._config.rmHomeContentShort[a].data){
						dataShort = dataShort + index._config.rmHomeContentShort[a].data;
					}else{
						dataShort = dataShort + index._config.rmHomeContentShort[a].outerHTML;
						
					}
					
				}
				if(document.getElementsByClassName('banner-home-short') != undefined && document.getElementsByClassName('banner-home-short')[0] != undefined){
					document.getElementsByClassName('banner-home-short')[0].innerHTML = dataShort;
				}
			}
				//$(".banner-home-long").html(index._config.rmHomeContentLong);
				//$(".banner-home-short").html(index._config.rmHomeContentShort);
				$('.distributor-partners-link').click(function () {
					$("#findLocalDistributor").click();
				});
				index._whereToBuy._bindings();
				if(index._config.user.isGridUser){
					$(".owl-wrapper").addClass("center-grid");
					$(".arrow-box-quotes").click();
				}
				$('.open-feedback-modal').click(function () {
					index._modals._bindings();
					index.elements.feedbackModalRMContact.modal("show");
				});
				
				index._whereToBuy._bindings();
			});
		};

		index.checkTabView = function () {
			if (index.currentTabView == "orders") {
				index.context.ordersTabActiveClass = "active";
				index.context.quotesTabActiveClass = "";
			} else if (index.currentTabView == "quotes") {
				index.context.ordersTabActiveClass = "";
				index.context.quotesTabActiveClass = "active";
			}
		};
		
		index.b2bUnitOnLoad = function () {
			var unitType = index._b2bUnit.unitType;
			if (unitType == "SAP") {
				index.elements.advancedSearchHomeBar.hide();
				index.elements.systemComponents.show();
			} else if (unitType == "ORACLE"){
				index.elements.advancedSearchHomeBar.show();
				index.elements.systemComponents.hide();
			}
		};

		index.ordersQuotesRoutine = function () {
			if (index._b2bUnit.isUnitSet) {
				var gotOrders = index._orders.getLastOrders(index.opts.numToDisplay).then(function (res) {
					if (res == null) return;
					index.context.orders = res.results;
				});
				var gotQuotes = index._quotes.getLastQuotes(index.opts.numToDisplay).then(function (res) {
					if (res == null) return;
					index.context.quotes = res.results;
				});

				$.when(gotOrders, gotQuotes).then(function () {
					index.context.flags.noB2bUnit = false;
					index.renderOrdersQuotes();
				}).fail(function (e) {
					console.log(e);
				});

			} else {

				index.context.flags.noB2bUnit = true;
				index.renderOrdersQuotes();

			}


		};

		index.initTabs = function () {
			index.currentTabView = (index._role.type == "epc") ? "quotes" : "orders";
			index.ordersQuotesRoutine();
		};

		index.handlers = {
			onSetTabView: function (tabView) {
				index.currentTabView = tabView;
			},
			onOrderTitleClick: function (geOrderNumber) {
				index._orders.showDetails(geOrderNumber);
			},
			onQuoteTitleClick: function (code) {
				index._quotes.showDetails(code);
			},
			onb2bUnitChange: function () {
				if (index._isActiveController) {
					index.ordersQuotesRoutine();
				}
			},
			onQuoteDeleted: function () {
				index.ordersQuotesRoutine();
			},
			onRMContactFeedbackFormSubmit: function (el) {
				var hasErrors = index._helpers.checkFormForErrors(el);
				if (hasErrors) {
					return;
				}

				var formData = index._utils.getFormData(el);

				index._api.index.sendRMContactFeedback(formData).then(function (res) {

					index.elements.feedbackModalRMContact.modal("hide");

					if (res && res.status == 200) {
						index._modals.success.show(index._messages.contactUsFormSuccess);
					} else {
						index._modals.warning.show(index._messages.feedbackError);
					}

				});

			}
		};

		index.renderOrdersQuotes = function () {
			index.checkTabView();
             
			var html = index.templates.ordersAndQuotes(index.context);

			index.elements.ordersAndQuotes.replaceWith(html);
			index.elements.ordersAndQuotes.hide().fadeIn("fast", function () {
				index._applyScript.base.owl();
			});

		};

		index.init = function () {

			index.populateInitialContext().then(function () {

				index._renderPageTemplate();

				index.initTabs();

				index.setCirclesToDisplay();

				index._bindings();
				
				index.pageOnLoad();

				index._events.dispatchEvent("controllerInitialized");
				
				index.b2bUnitOnLoad();

				index._events.registerHandlerAsLastOne("b2bUnitChanged", index.name, index.handlers.onb2bUnitChange);
				index._events.registerHandlerAsLastOne("quoteDeleted", index.name, index.handlers.onQuoteDeleted);

			});

		};


		return index;
	};

	window.appComponents = appComponents;

})(window.appComponents || {});